import { defineMessages } from 'react-intl-next';

const _default_1: {
	starred: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pickerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pickerLabelGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	starred: {
		id: 'atlassian-studio-common.picker.favourite',
		defaultMessage: 'Starred',
		description: 'Label for starred project/spaces in picker',
	},
	all: {
		id: 'atlassian-studio-common.picker.all',
		defaultMessage: 'All',
		description: 'Label for remaining project/spaces in picker',
	},
	pickerLabel: {
		id: 'atlassian-studio-common.picker.label',
		defaultMessage: 'Jira projects and Confluence spaces search picker',
		description: 'Accessibility label for the picker search input',
	},
	pickerLabelGalaxia: {
		id: 'atlassian-studio-common.picker.label-galaxia',
		defaultMessage: 'Jira and Confluence spaces search picker',
		description: 'Accessibility label for the picker search input',
	},
});
export default _default_1;
